module.exports = __webpack_public_path__ + "static/media/street5.ddc0cb11.jpg";